import useGetApplicationPlatform from './useGetApplicationPlatform'

export default useGetApplicationPlatform
